@if ((customerData$ | async) || {}; as customer) {
<tux-page-header
  pageTitle="Manage Users"
  [breadcrumbs]="[
    { path: '', title: 'Home' },
    { path: '/application-manager', title: 'Current Customers' },
    {
      path: '/application-manager/' + customer.customerId,
      title: customer.name || 'Customer'
    },
    { title: 'Manage Users' }
  ]"
  [subMenu]="false"
>
  <tux-page-header-buttons>
    <p-button
      type="primary"
      label="Add Users"
      styleClass="font-medium"
      (click)="addUsers()"
    ></p-button>
  </tux-page-header-buttons>
</tux-page-header>
}

<ng-template #switchRenderer let-column="column" let-row="row">
  <div class="card flex justify-center gap-4">
    <p-toggleswitch
      (ngModelChange)="onToggleChange($event, row, column)"
      [(ngModel)]="row[column]"
    >
      <i
        [ngClass]="[
          '!text-xs',
          'fa',
          row[column] ? 'fa-check-circle-o' : 'fa-times-circle'
        ]"
      ></i>
    </p-toggleswitch>
  </div>
</ng-template>

<ng-template #actionsRenderer let-row="row">
  <div class="flex gap-2">
    <p-button (click)="deleteUser(row)" aria-label="Delete User" variant="text">
      <fa-icon [icon]="faTrashCan"></fa-icon>
    </p-button>
    <p-button (click)="updateUser(row)" aria-label="Edit User" variant="text">
      <fa-icon [icon]="faUser"></fa-icon>
    </p-button>
  </div>
</ng-template>

<div>
  <!-- Disabled the filters for now -->
  <!--  <div class="flex gap-4 w-full">-->
  <!--    <tux-mini-filter-->
  <!--      header="Filter By Product"-->
  <!--      [options]="productOptions"-->
  <!--      [formControlInput]="productControl"-->
  <!--    ></tux-mini-filter>-->
  <!--    <tux-mini-filter-->
  <!--      header="Filter By Admin"-->
  <!--      [options]="adminOptions"-->
  <!--      [formControlInput]="adminControl"-->
  <!--    ></tux-mini-filter>-->
  <!--  </div>-->
  <lib-table-wrapper
    [config]="{
      data: usersData$,
      columnPicker: true,
      columns: (columns$ | async) || [],
      download: true,
      downloadTableCSV: true,
      search: true,
      sort: false,
      globalFilterFields: ['name'],
      defaultColumns: (defaultColumns$ | async) || [],
    }"
    [loading]="loading"
  ></lib-table-wrapper>
</div>
